import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { NavService } from '../../core/nav.service';
import { CourseService } from '../shared/course.service';
import { APPCONFIG } from "../../config";

@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html'
})
export class CoursesComponent implements OnInit {
  filter: Observable<any>;
  AppConfig: any;

  constructor(route: ActivatedRoute, private nav: NavService, public service: CourseService) {
    this.filter = route.params
      .pluck('status')
      .do((value: string) => service.filterStatus(value));
  }

  ngOnInit() {
    this.initNav();
    this.AppConfig = APPCONFIG;
  }

  get title() {
    return this.nav.title;
  }

  private initNav() {
    this.nav.title = '강좌 목록';
    this.nav.actions = [
      { text: 'arrow_back', commands: ['/intro'] }
    ];
    this.nav.slackUrl = null;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/courses/courses.component.ts